<div class="td-cnt-ext" [style.top.px]="topPx">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <i *ngIf="dialogIcon != ''" class="{{dialogIcon}} dialog-icon"></i>
            <span class="te-title">{{dialogTitle}}</span>
        </div>
        <div class="td-cnt-body" *ngIf="headerAndItemParametersReady">
            <!-- ENQUIRY -->
            <div class="cnt-grid">
                <teiasoft-grid [title]="'edit-enquiry-enquiry'" [gridDescription]="'enquiryBook.header' | translate"
                    [columnsToShow]="columnsToShowHeader" [dataSet]="dataSet" [showFooter]="false" [selectable]="false"
                    [theme]="theme" [autoWidth]="true" [showEditIcon]="true" (rowEditClick)="rowEditClick($event)"
                    [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!" [sortable]="false"
                    [gridName]="'enquiries'" style="width: 100%;"></teiasoft-grid>
            </div>

            <!-- ITEMS -->
            <div class="cnt-grid" style="margin-top: 0.4rem;">
                <teiasoft-grid [title]="'edit-enquiry-item'" [gridDescription]="'enquiryBook.items' | translate"
                    [customIcoCols]="customIcoCols" [columnsToShow]="columnsToShowItem" [dataSet]="dataSetItems"
                    [virtualScroll]="true"
                    [showFooter]="false" [selectable]="false" [disableAllSelection]='false' [theme]="theme"
                    [autoWidth]="true" [showEditIcon]="false" [dateFormat]="globals.dateFormat!"
                    [dateTimeFormat]="globals.dateTimeFormat!" [sortable]="false"
                    [gridDescriptionExtraTemplate]="itemsGridTotalsTemplate" [gridDescriptionExtraContext]="{
                        hasTotals: hasEnquiryTotals(),
                        totalPrice: enquiryTotalPriceFormatted,
                        totalMargin: enquiryTotalMarginFormatted,
                        marginClass: enquiryTotalMarginClass
                    }" (customIconClick)="customIconClick($event)"
                    (customIconContextMenuClick)="customIconContextMenuClick($event)" [calculatedCols]="calculatedCols"
                    [enquiryNo]="enquiryToEdit.enquiryNo!" [gridName]="'items'" [salesOfficeId]="salesOfficeId"
                    [origin]="'edit-enquiry'" [discardEditChanges]="discardEditChanges"
                    (reloadMyDataset)="reloadMyDataset($event)" [customRenderers]="customRenderers"
                    [customHeaderRenderers]="customHeaderRenderers" style="width: 100%;"
                    [enquiryHeader]="enquiryToEdit.header!"
                    (onOpenITDCR)="onOpenItdcrClick($event)"></teiasoft-grid>
            </div>
            <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}" style="border-top: none !important;">
                <teiasoft-button *ngIf="priceEdited" class="mr-5" [text]="'commons.apply' | translate" [theme]="theme"
                    [isMobile]="isMobile" (onClick)="onApplyModificationFromEdit()"
                    [type]="'tb-secondary'"></teiasoft-button>
                <teiasoft-button *ngIf="priceEdited" class="mr-5" [text]="'commons.discard' | translate" [theme]="theme"
                    [isMobile]="isMobile" (onClick)="onDiscardModificationFromEdit()"
                    [type]="'tb-cancel'"></teiasoft-button>
                <input type="file" class="file-upload" (change)="onFileSelected($event)" style="display: none;"
                    id="fileUpload">
                <input type="file" class="file-upload" (change)="onPriceFileSelected($event)" style="display: none;"
                    id="filePriceUpload">
                <div class="add-item mr-5">
                    <teiasoft-button *ngIf="!priceEdited" [text]="'enquiryBook.addItems' | translate" [theme]="theme"
                        [isMobile]="isMobile" (onClick)="onAddItemClick()" [disabled]="itemButtonsDisabled"
                        [secondaryActionIcon]="'fa-solid fa-sparkles'"
                        (onSecondaryActionClick)="onAddItemFromIAClick()"></teiasoft-button>
                </div>
                <teiasoft-button mat-button [matMenuTriggerFor]="editInPlaceMenu" *ngIf="!priceEdited"
                    [text]="'enquiryBook.editInPlace' | translate" [theme]="theme" [isMobile]="isMobile"
                    class="mr-5"></teiasoft-button>
                <mat-menu #editInPlaceMenu="matMenu" yPosition="above">
                    <teiasoft-button *ngIf="!priceEdited" class="menu-button"
                        [text]="'enquiryBook.downloadItems' | translate" [theme]="theme" [isMobile]="isMobile"
                        (onClick)="onDownloadItemsClick()"
                        [disabled]="itemButtonsDisabled || !enquiryToEdit.items || enquiryToEdit.items.length == 0"></teiasoft-button>
                    <teiasoft-button *ngIf="!priceEdited" [text]="'commons.edit' | translate" [theme]="theme"
                        [isMobile]="isMobile" (onClick)="onEditInPlaceClick()" [disabled]="itemButtonsDisabled"
                        class="menu-button"></teiasoft-button>
                    <teiasoft-button *ngIf="!priceEdited" [text]="'commons.upload' | translate" [theme]="theme"
                        [isMobile]="isMobile" (onClick)="onUploadItemsClick()" [type]="'tb-secondary'"
                        [disabled]="itemButtonsDisabled" class="menu-button"></teiasoft-button>
                </mat-menu>

                <teiasoft-button mat-button [matMenuTriggerFor]="atLeastOneCostValid()? priceMenu : null"
                    *ngIf="!priceEdited" [text]="'enquiryBook.editPrices' | translate" [theme]="theme"
                    [isMobile]="isMobile" [disabled]="!atLeastOneCostValid()"></teiasoft-button>
                <mat-menu #priceMenu="matMenu" yPosition="above">
                    <teiasoft-button *ngIf="!priceEdited" class="menu-button"
                        [text]="'enquiryBook.downloadItemsPrice' | translate" [theme]="theme" [isMobile]="isMobile"
                        (onClick)="onDownloadItemsPriceClick()" [disabled]="itemButtonsDisabled"></teiasoft-button>
                    <teiasoft-button *ngIf="!priceEdited" [text]="'commons.edit' | translate" [theme]="theme"
                        [isMobile]="isMobile" (onClick)="onEditCostsClick()" [disabled]="itemButtonsDisabled"
                        class="menu-button"></teiasoft-button>
                    <teiasoft-button *ngIf="!priceEdited" [text]="'commons.upload' | translate" [theme]="theme"
                        [isMobile]="isMobile" (onClick)="onUploadItemsPriceClick()" [disabled]="itemButtonsDisabled"
                        [type]="'tb-secondary'" class="menu-button"></teiasoft-button>
                </mat-menu>

            </div>
        </div>
        <div *ngIf="!priceEdited" class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button *ngIf="dataSetItems && dataSetItems.length > 0" (onClick)="onSearchForSimilarEnquiries()"
                class="mr-5" style="flex: 1;" [text]="'enquiryBook.searchSimilarEnquiries' | translate" [theme]="theme"
                [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onDiscardClick()" class="mr-5"
                [text]="'enquiryBook.discardCurrentVersion' | translate" [theme]="theme"
                [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseEditingClick()" class="mr-5"
                [text]="'enquiryBook.closeEditingSession' | translate" [theme]="theme"
                [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onReturnEnquiryBookClick()" class="mr-5" [type]="'tb-cancel'"
                [text]="'enquiryBook.returnEnquiryBook' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>

<!-- MODAL EDIT FORM -->
<!--     [action]="'edit'" -->
<teiasoft-dialog *ngIf="showEditDialog" [theme]="theme!" [isMobile]="false" [dialogTitle]="dialogTitle"
    [dialogIcon]="dialogIcon" [dialogForm]="enquiryForm" [display]="'row'" [elementPerRow]="elementPerRow"
    [dialogButtons]="dialogButtons" (onButtonClick)="onDialogButtonClick($event)"
    (onFormButtonClick)="onFormButtonClick($event)" (onFormSelectChanged)="onFormSelectChanged($event)"
    (onFormSelectListChanged)="onFormSelectListChanged($event)"
    (onFormAutocompleteChanged)="onFormAutocompleteChanged($event)"
    (onFormAutocompletLinkClicked)="onFormAutocompletLinkClicked($event)"
    (onFormAutocompleteChangedRows)="onFormAutocompleteChangedRows($event)" (onFormReady)="onFormReady($event)"
    (onFormAutocompleteInputChange)="onFormAutocompleteInputChange($event)"
    (onFormAutocompleteRemoveElement)="onFormAutocompleteRemoveElement($event)"
    [enquiryAttachments]="enquiryAttachments" [enquiryNo]="enquiryToEdit.enquiryNo!"></teiasoft-dialog>

<!-- MODAL SELECT NPS -->
<app-modal-select-nps *ngIf="showSelectNps" (onCloseModalNps)="onCloseModalNps($event)" [dataSet]="dataSetNps"
    [modalTitle]="'enquiryBook.selectNps' | translate" [columns]="columnsNps" [columnsToHide]="columnsToHideNps"
    (onConfirmModalNps)="onConfirmModalNps($event)" [selectedRow]="selectedNpsRow"
    [columnsToFilter]="columnsToFilterNps"></app-modal-select-nps>

<!-- MODAL ITEM -->
<app-modal-item *ngIf="showModalItem" [isMobile]="false" [theme]="theme!" [itemParameterValues]="itemParameterValues"
    [itemParameterLengthValues]="itemParameterLengthValues" [materials]="materials"
    (closeModalItem)="closeModalItem($event)" [items]="items" [action]="itemAction"
    [selectedIndexItem]="selectedIndexItem" (reloadEnquiry)="onReloadEnquiry($event)"
    [enquiryNo]="enquiryToEdit.enquiryNo!" [enquiryToEdit]="enquiryToEdit"
    [roundDigitsForItemForm]="roundDigitsForItemForm"></app-modal-item>

<!-- EDIT IN PLACE -->
<app-modal-editinplace *ngIf="showEditInPlace" [theme]="theme" [isMobile]="isMobile" [dataSet]="itemsToEdit"
    [columnsToHide]="columnsToHideItems" (closeEditInPlace)="closeEditInPlace()" [dateFormat]="globals.dateFormat!"
    [columnsToShow]="columnsToShowItemEditInPlace" [dateTimeFormat]="globals.dateTimeFormat!"
    [columnsRequired]="columnsRequired" [columnsSelect]="columnsSelect" [columnsBoolean]="columnsBoolean"
    (changedEditInPlace)="changedEditInPlace($event)" (deleteItemsEditInPlace)="deleteItemsEditInPlace($event)"
    (gridReady)="onEditInPlaceGridReady()" [itemsFromXlsx]="itemsFromXlsx"
    [roundDigitsForEditInPlace]="roundDigitsForEditInPlace" [enquiryNo]="enquiryToEdit.enquiryNo!"
    [enquiry]="enquiryToEdit" [materials]="materials">
</app-modal-editinplace>
<!-- EDIT IN PLACE COSTS -->
<app-modal-editinplace-costs *ngIf="showEditCosts" [theme]="theme" [isMobile]="isMobile"
    (onSave)="onSaveEditInPlaceCosts($event)" (closeModal)="showEditCosts = false"
    [enquiryNo]="enquiryToEdit.enquiryNo!" [items]="itemsToEdit" [itemsPricesFromXlsx]="itemsPricesFromXlsx"
    [itemVisibleColumns]="itemPriceVisibleColumns" [itemCostsColumns]="itemCostsVisibileColumns"
    [enquiryHeader]="enquiryToEdit.header!">
</app-modal-editinplace-costs>
<!-- EXTRA COSTS MODAL-->
<app-modal-add-order-extra-costs *ngIf="showOrderExtraCosts" [columnsToShowItem]="columnsToShowItem"
    [amount]="enquiryToEdit.header?.orderExtraCost?.amount || 0"
    [selectedItemsNo]="enquiryToEdit.header?.orderExtraCost?.items || []" [enquiryNo]="enquiryToEdit.enquiryNo!"
    [items]="dataSetItems" [customIcoCols]="[]" [calculatedCols]="calculatedCols"
    [unitSystem]="enquiryToEdit.header?.unitSystem!" [currency]="enquiryToEdit.header?.currency!" (onCancel)="showOrderExtraCosts = false;"
    (onSave)="onSaveOrderExtraCosts($event)"></app-modal-add-order-extra-costs>
<app-modal-extra-costs *ngIf="showExtraCosts" (onSave)="onSaveItemExtraCosts($event)"
    (onCancel)="showExtraCosts = false" [enquiryNo]="enquiryToEdit.enquiryNo!"
    [enquiryHeader]="enquiryToEdit.header!" [item]="selectedExtraCostItem!">
</app-modal-extra-costs>
<!-- MODAL DELIVERY DATES -->
<app-modal-item-delivery-dates *ngIf="showItemDeliveryDates" (onCancel)="showItemDeliveryDates = false"
    [enquiryNo]="enquiryToEdit.enquiryNo!" [item]="selectedDeliveryDatesItem!">
</app-modal-item-delivery-dates>

<!-- MODAL UPLOAD AI -->
<app-modal-upload-items-ia *ngIf="showUploadFromAI" (onCancel)="showUploadFromAI = false"
    (onUploadComplete)="onItemAIUploadComplete($event)"
    [enquiryNo]="enquiryToEdit.enquiryNo!"></app-modal-upload-items-ia>

<!-- MODAL COSTING TOOL -->
<app-modal-costing-tool *ngIf="showCostingToolModal" [enquiryNo]="enquiryToEdit.enquiryNo!" [item]="costingToolItem!"
    [origin]="'edit-enquiry'" [unitSystem]="enquiryToEdit.header?.unitSystem!" [currency]="enquiryToEdit.header?.currency!"
    (onClose)="onCloseCostingTool()"></app-modal-costing-tool>
<app-modal-view-itdcr *ngIf="showItdcrViewerModal" [itdcrNo]="itdcrViewerNo" [showHistory]="itdcrViewerShowHistory"
    (onClose)="onCloseItdcrViewer()"></app-modal-view-itdcr>

<!-- MODAL SPECIAL REQUIREMENTS -->
<app-modal-special-requirements *ngIf="showSpecialRequirements" (onClose)="showSpecialRequirements = false"
    (onSave)="onSaveSpecialeRequirements($event)" [readOnly]="false"
    [initialCustomerSpecialRequirements]="this.enquiryToEdit.header!.customerSpecialRequirements || []"></app-modal-special-requirements>

<!-- CUSTOM CELLS FOR ITEMS GRID -->
<ng-template #viewCost let-row let-column="column" let-uomColumn="uomColumn" let-warningClass="warningClass">
    <div class="extra-cost-row" [ngClass]="warningClass">
        <span style="margin-right: 0.2vw;">{{ (row[column] && row[column].toFixed(2))}}</span>
    </div>
</ng-template>
<ng-template #viewCostNumeric let-row let-column="column" let-uomColumn="uomColumn">
    <div class="extra-cost-row">
        <ng-container *ngIf="row[column] !== null && row[column] !== undefined && row[column] !== ''; else dash">
            <span style="margin-right: 0.2vw;">
                {{ row[column].toFixed(2) }}
            </span>
        </ng-container>

        <ng-template #dash>
            <span>-</span>
        </ng-template>
    </div>
</ng-template>
<ng-template #viewExtraCosts let-row>
    <div class="extra-cost-row">
        <span style="margin-right: 0.2vw;">{{row.extraCosts!! && row.extraCosts.toFixed(2)}}</span>
        <div *ngIf="!priceEdited" class="extra-cost-ico-cell"><i (click)="onItemExtraCostsClick(row)"
                class="extra-cost-icon fal fa-edit"></i></div>
    </div>
</ng-template>
<ng-template #viewActualCm let-row let-column="column">
    <div class="cost-row" *ngIf="row.costsStatus == 'Validated'">
        <input type="string" class="input-editable-fullwidth" (input)="onPriceChange($event,row[column])"
            (focusout)="onInputActualCm($event, row, column)" (keydown.enter)="onInputActualCm($event, row, column)"
            [value]="(row[column] && row[column].toFixed(2)) || 0">
    </div>
</ng-template>
<ng-template #viewMargin let-row let-column="column">
    <div class="cost-row cost-margin" *ngIf="row.costsStatus == 'Validated'">
        <input type="string" class="input-editable-fullwidth" (input)="onPriceChange($event,row[column], false)"
            (focusout)="onInputMargin($event, row, column)" (keydown.enter)="onInputMargin($event, row, column)"
            [disabled]="column === 'agentFee' && !isAgentFeeEditable(row)"
            [value]="(row[column] && row[column].toFixed(2)) || 0">
    </div>
</ng-template>
<ng-template #viewFinalPrice let-row>
    <div class="cost-row" *ngIf="row.costsStatus == 'Validated'">
        <input type="string" class="input-editable" (input)="onPriceChange($event,row.finalPrice,false)"
            (keydown.enter)="onInpuFinalPrice($event, row)" (focusout)="onInpuFinalPrice($event, row)"
            [value]="row['finalPrice'] && row['finalPrice'].toFixed(2)" [ngClass]="{
                'bg-red': ( (+row.finalPrice < +row.minimumPrice) || (+row.recommendedFm == 0 && +row.recommendedPrice == +row.finalPrice )),
                'bg-yellow': +row.finalPrice >= +row.minimumPrice && +row.finalPrice < +row.recommendedPrice,
                'bg-green': (row.finalPrice) && (+row.finalPrice >= +row.recommendedPrice)
            }">
    </div>
</ng-template>
<ng-template #viewDeliveryDates let-row>
    <div class="extra-cost-row">
        <span style="margin-right: 0.1vw;">{{getItemRowMinDeliveryDate(row)}}</span>
        <span style="margin-right: 0.2vw;" *ngIf="getItemRowDeliveryDatesCollection(row).length > 1">*</span>
        <div *ngIf="getItemRowDeliveryDatesCollection(row).length > 1" class="extra-cost-ico-cell"><i
                (click)="onItemDeliveryDatesClick(row)" class="extra-cost-icon fal fa-magnifying-glass"></i></div>
    </div>
</ng-template>
<ng-template #viewExtraLeadTime let-row>
    <div class="cost-row">
        <!-- (input)="onExtraLeadTimeChange($event,row['extraLeadTime'])" -->
        <input type="text" class="input-editable" [value]="row['extraLeadTime']"
            (input)="onPriceChange($event, row.extraLeadTime,true)" (focusout)="onInputExtraLeadTime($event, row)"
            (keydown.enter)="onInputExtraLeadTime($event, row)">
        <span style="flex: 0.1;">{{'commons.weeks' | translate}}</span>
    </div>
</ng-template>
<ng-template #viewDeliveryNotes let-row>
    <div class="cost-row">
        <!-- (input)="onExtraLeadTimeChange($event,row['extraLeadTime'])" -->
        <input class="input-editable" [value]="row['deliveryNotes']" (input)="onInputDeliveryNotes($event, row)"
            (focusout)="onInputDeliveryNotes($event, row)" (keydown.enter)="onInputDeliveryNotes($event, row)">
    </div>
</ng-template>

<ng-template #viewCostHeader let-column="column">
    <span>{{getCostColumnHeaderLabel(column)}}</span>
</ng-template>

<ng-template #viewExtraCostsHeader let-column="column">
    <div style="display: flex;">
        <span>{{getCostColumnHeaderLabel(column)}} </span>
        <span *ngIf="!priceEdited" class="extra-cost-ico-cell"><i (click)="onOrderExtraCostsClick()"
                class="extra-cost-icon fal fa-edit" style="color: white !important;"></i></span>
    </div>
</ng-template>
<ng-template #itemsGridTotalsTemplate let-hasTotals="hasTotals" let-totalPrice="totalPrice"
    let-totalMargin="totalMargin" let-marginClass="marginClass">
    <div *ngIf="hasTotals" class="total-margin">
        <div class="total-row">
            <span>{{'enquiryBook.overallPrice' | translate}} :</span>
            <span>{{totalPrice}}</span>
        </div>
        <div class="total-row">
            <span [ngClass]="marginClass">{{'enquiryBook.overallMargin' | translate}} :</span>
            <span [ngClass]="marginClass">{{totalMargin}}</span>
        </div>
    </div>
</ng-template>

<ng-template #viewMismatch let-row let-column="column">
    <div class="mismatch-wrapper" [ngClass]="{'mismatch' : hasMismatch(row,column)}">
        <span class="tg-cell-value" style="margin-left: 0.5vw;">{{getBooleanValueLabel(row[column])}}</span>
    </div>
</ng-template>
